export var SET_NAV_GROUP = 'SET_NAV_GROUP';
export var setNavGroup = function setNavGroup(navItem) {
  return {
    type: SET_NAV_GROUP,
    payload: navItem
  };
};